import { AdPlacementsComponentTypes } from '@bingads-webui-campaign-react/ad-placement-consts';

const image191100AdsLib = {
  componentType: AdPlacementsComponentTypes.AdPlacementPreview,
  key: '191x100_AdsLib',
  aspectRatio: 1.91,
  type: 'Image191x100',
  associationType: 'LandscapeImageMedia',
  imagePreviewHeight: 150,
  isRequired: true,
  minimumRequirements: 1,
  minSize: [703, 368],
  maxSize: [0, 0],
  localizedText: {
    previewTypeStringKey: _TL_('Landscape Image Multimedia Ad'),
    stringKey: _TL_('1.91:1'),
  },
  previewSettings: {
    showAdsLabel: false,
    showImage: true,
    showDescription: true,
    showShortHeadline: true,
    showAdditionalDisclaimer: false,
    showAction: false,
    showUrl: true,
    showPreviewTypeString: false,
  },
  styleOverrides: {
    adsLabel: {
      backgroundColor: 'white',
    },
    description: {
      color: '#605E5C',
      maxWidth: 250,
      wordWrap: 'break-word',
      paddingRight: 16,
      fontSize: 12,
    },
    previewContent: {
      margin: 'auto',
      background: '#fff',
      border: 'solid',
      borderWidth: 'thin',
      color: '#ddd',
    },
    shortHeadline: {
      fontSize: 14,
      fontWeight: 200,
      paddingBottom: 5,
      color: '#207697',
    },
    textContainer: {
      padding: '8px 20px 20px 20px',
      maxWidth: '-webkit-fill-available',
      width: 286,
      lineHeight: 1.1,
    },
    finalUrl: {
      color: 'green',
      fontSize: 12,
      marginBottom: 8,
    },
    actionButton: {
      right: 15,
      bottom: 15,
      padding: '6px 16px 8px 16px',
      fontSize: 16,
      fontWeight: 'bold',
      borderRadius: 32,
    },
  },
};

export default image191100AdsLib;
